<template>
  <div class="loading-container">
    <div class="custom-spinner" :class="`spinner-${size}`">
      <div class="spinner-circle"></div>
    </div>
    <div class="loading-tip">{{ tip }}</div>
  </div>
</template>

<script>
export default {
  name: 'LoadingView',
  props: {
    // loading文字提示
    tip: {
      type: String,
      default: '加载中...'
    },
    // spin大小
    size: {
      type: String,
      default: 'default',
      validator: value => ['small', 'default', 'large'].includes(value)
    },
    // 最小高度
    minHeight: {
      type: String,
      default: '200px'
    },
    // 自定义容器样式
    // containerStyle: {
    //   type: Object,
    //   default: () => ({})
    // }
  }
}
</script>

<style scoped>
.loading-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
  gap: 20px;
}

.custom-spinner {
  display: inline-block;
}

.spinner-circle {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #1890ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.spinner-small .spinner-circle {
  width: 20px;
  height: 20px;
  border-width: 2px;
}

.spinner-large .spinner-circle {
  width: 48px;
  height: 48px;
  border-width: 4px;
}

.loading-tip {
  color: #666;
  font-size: 14px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>